import { useEffect, useState } from 'react';
import { GetMonitors } from '../common/uptimerobot.js';
import { formatDuration, formatNumber } from '../common/helper.js';
import Link from './link.js';
import { t } from '../common/i18n.js';

function UptimeRobot({ apikey, locale }) {

  const status = {
    ok: t(locale, 'statusOk'),
    down: t(locale, 'statusDown'),
    unknow: t(locale, 'statusUnknown')
  };

  const { CountDays, ShowLink } = window.Config;

  const [monitors, setMonitors] = useState();
  const [error, setError] = useState('');
  const [retryKey, setRetryKey] = useState(0);

  useEffect(() => {
    let isMounted = true;
    setError('');
    GetMonitors(apikey, CountDays)
      .then((data) => {
        if (!isMounted) return;
        setMonitors(data);
      })
      .catch((err) => {
        if (!isMounted) return;
        const status = err?.response?.status;
        if (status === 429) {
          setError(t(locale, 'errorTooManyRequests'));
        } else {
          setError(t(locale, 'errorLoadFailed'));
        }
      });

    return () => {
      isMounted = false;
    };
  }, [apikey, CountDays, locale, retryKey]);

  const handleRetry = () => {
    setRetryKey((prev) => prev + 1);
  };

  if (error) return (
    <div className='site'>
      <div className='summary is-error'>
        <span>{t(locale, 'notice')}</span>
        <span>{error}</span>
        <span>
          <button className='retry-button' type='button' onClick={handleRetry}>{t(locale, 'retry')}</button>
        </span>
      </div>
    </div>
  );

  if (monitors) return monitors.map((site) => (
    <div key={site.id} className='site'>
      <div className='meta'>
        <span className='name'>{site.name}</span>
        {ShowLink && <Link className='link' to={site.url} text={site.name} />}
        <span className={'status ' + site.status}>{status[site.status]}</span>
      </div>
      <div className='timeline'>
        {site.daily.map((data, index) => {
          const uptime = Number(data.uptime);
          let status = '';
          if (uptime >= 99.99) {
            status = 'ok';
          }
          else if (uptime <= 0 && data.down.times === 0) {
            status = 'none';
          }
          else {
            status = 'down';
          }
          return (<i key={index} className={status} />)
        })}
      </div>
      <div className='summary'>
        <span>{t(locale, 'today')}</span>
        <span>
          {site.total.times
            ? `${t(locale, 'recentDays', { days: CountDays })} ${t(locale, 'incidentsAndDuration', { times: site.total.times, duration: formatDuration(site.total.duration, locale), average: site.average })}`
            : `${t(locale, 'recentDays', { days: CountDays })} ${t(locale, 'uptimeOnly', { average: site.average })}`}
        </span>
        <span>{site.daily[site.daily.length - 1].date.format('YYYY-MM-DD')}</span>
      </div>
    </div>
  ));

  else return (
    <div className='site'>
      <div className='loading' />
    </div>
  );
}

export default UptimeRobot;
